"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Throttle a function to only run every {wait} milliseconds. Even if called plently.
 * That means that any call inbetween will be _ignored_ !
 * For the difference between debounce and throttled see:
 * https://codeburst.io/throttling-and-debouncing-in-javascript-646d076d0a44
 * @param  {any} func
 * @param  {number} wait
 */
var throttled = function (func, wait) {
    var lastCall = 0;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var now = new Date().getTime();
        if (now - lastCall < wait) {
            return;
        }
        lastCall = now;
        return func.apply(void 0, __spread(args));
    };
};
exports.default = throttled;
